import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { brand, navLinks } from "@/mocks/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer" aria-label={`${brand.name} 首页`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            爆
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
              {brand.name}
            </span>
            <span className="mt-1 hidden text-[10px] tracking-[0.18em] text-foreground-500 sm:block">
              投稿选题参考平台
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `relative px-3.5 py-2 text-sm transition-colors cursor-pointer ${
                  isActive
                    ? "text-primary-600 font-semibold"
                    : "text-foreground-600 hover:text-foreground-950"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/submit"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-fill text-base leading-none"></i>
            立即投稿
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden cursor-pointer"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={`text-xl leading-none ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="flex flex-col px-4 py-3" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-100 font-semibold text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/submit"
              className="mt-2 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 cursor-pointer"
            >
              <i className="ri-send-plane-fill text-base leading-none"></i>
              立即投稿
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}